import React, { useState } from 'react';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import { PATHS } from 'AppPaths';
import { NAV_LINKS } from 'consts';
import { Link } from 'util/router';

import { CustomButton } from './styles';

const LoggedOutNavItems = ({ isSmallMobile, onLoginClick }) => {
  const [mobileMenuAnchorEl, setMobileMenuAnchorEl] = useState(null);
  const isMobileMenuOpen = Boolean(mobileMenuAnchorEl);

  const openMobileMenu = (event) => {
    setMobileMenuAnchorEl(event.currentTarget);
  };

  const closeMobileMenu = () => {
    setMobileMenuAnchorEl(null);
  };

  const handleLoginClick = () => {
    onLoginClick();
    closeMobileMenu();
  };

  const handleSignUpClick = () => {
    closeMobileMenu();
  };

  if (isSmallMobile) {
    return (
      <Box>
        <IconButton
          color="inherit"
          aria-label="open authentication menu"
          onClick={openMobileMenu}
          edge="end"
          sx={{ paddingRight: '30px' }}
        >
          <MoreHorizIcon />
        </IconButton>
        <Menu
          id="mobile-auth-menu"
          anchorEl={mobileMenuAnchorEl}
          open={isMobileMenuOpen}
          onClose={closeMobileMenu}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
          disableScrollLock={true}
        >
          <MenuItem onClick={handleLoginClick}>Log in</MenuItem>
          <MenuItem
            component={Link}
            to={PATHS.PRODUCTS_PAGE}
            onClick={handleSignUpClick}
          >
            Sign up
          </MenuItem>
          {NAV_LINKS.map((link) => (
            <MenuItem
              key={link.path}
              component={Link}
              to={link.path}
              onClick={closeMobileMenu}
            >
              {link.name}
            </MenuItem>
          ))}
        </Menu>
      </Box>
    );
  }

  return (
    <Box display="flex" gap={2} maxWidth="min-content">
      <CustomButton
        variant="text"
        component={Link}
        to={PATHS.PRODUCTS_PAGE}
        sx={{ '&:hover': { backgroundColor: '#6b6b6b21' } }}
      >
        Sign up
      </CustomButton>
      <CustomButton
        variant="contained"
        sx={{ color: '#ffffff', backgroundColor: '#6b6b6b' }}
        onClick={onLoginClick}
      >
        Log in
      </CustomButton>
    </Box>
  );
};

export default LoggedOutNavItems;
